import {
  BILL,
  CANCELED,
  ERROR,
  FINISH,
  IN_PROGRESS,
  NEED_TO_CHECK,
  PLACED,
  REGISTRY_COMPLETED,
  REPAY,
  SKIPED,
  TIMEOUT_CANCEL,
  VERIFIED,
  WAIT_CONFIRMATION,
  WAIT_CVV,
  WAIT_OTP,
  WAIT_SUPPORT_CONFIRMATION,
  WAIT_USER_REGISTRATION,
  REGISTRY_READY,
} from "@js-app/const/operation-statuses-ids";

export const OPERATION_STATUSES = {
  [SKIPED]: "skipped",
  [PLACED]: "created",
  [VERIFIED]: "verified",
  [IN_PROGRESS]: "pending",
  [FINISH]: "success",
  [ERROR]: "error",
  [CANCELED]: "cancel",
  [WAIT_OTP]: "pending",
  [WAIT_CONFIRMATION]: "pending",
  [BILL]: "pending",
  [REPAY]: "pending",
  [WAIT_USER_REGISTRATION]: "pending",
  [NEED_TO_CHECK]: "pending",
  [TIMEOUT_CANCEL]: "cancel",
  [WAIT_CVV]: "pending",
  [WAIT_SUPPORT_CONFIRMATION]: "pending",
  [REGISTRY_COMPLETED]: "completed",
  [REGISTRY_READY]: "registry_ready",
};
